export type BillRateShiftRowTone = 'full' | 'medium' | 'dim'

export function getBillRateShiftRowTone(
  shift: { endsAt: string; invoiced: boolean },
  now: Date = new Date()
): BillRateShiftRowTone {
  const isPast = new Date(shift.endsAt) < now
  if (!isPast) {
    return 'full'
  }
  if (shift.invoiced) {
    return 'dim'
  }
  return 'medium'
}
